import { __assign } from "tslib";
// tslint:disable-next-line: max-line-length
import { createFakeGetResponder, createFakePutResponder, createFakePostResponder } from '../test-utils';
import { createHttpTestKit } from '../http/test-kit';
import { createWidgetApi } from './';
import { createWidgetSettingsApiTestKit } from './settings/testkit';
export var createWebhooksApiTestKit = function () {
    var fakeHttp = createHttpTestKit();
    var api = createWidgetApi('', fakeHttp);
    // @ts-ignore - Ignore the error here, or handle wildcard ('*') param
    var testKit = {
        whenGetWidget: function (widgetId) {
            return createFakeGetResponder(fakeHttp, "/widgets/" + widgetId);
        },
        whenGetWidgets: function () {
            return createFakeGetResponder(fakeHttp, '/widgets');
        },
        whenGetWidgetCostomCss: function (widgetId) {
            return createFakeGetResponder(fakeHttp, "/widgets/" + widgetId + "/settings/advanced/css");
        },
        whenGetWidgetCostomJs: function (widgetId) {
            return createFakeGetResponder(fakeHttp, "/widgets/" + widgetId + "/settings/advanced/js");
        },
        whenUpdateWidgetChatSettings: function (dto) {
            return createFakePutResponder(fakeHttp, "/widgets/" + dto.widgetId + "/settings/modules/chat")(dto);
        },
        whenEnableWidgetChatModule: function (widgetId) {
            return createFakePostResponder(fakeHttp, "/widgets/" + widgetId + "/settings/modules/chat/enable")({});
        },
        whenDisableWidgetChatModule: function (widgetId) {
            return createFakePostResponder(fakeHttp, "/widgets/" + widgetId + "/settings/modules/chat/enable")({});
        },
        settings: createWidgetSettingsApiTestKit()
    };
    return __assign(__assign({}, api), testKit);
};
//# sourceMappingURL=testkit.js.map